import type { SVGProps } from 'react';

const SvgStoreBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M5.95632 12C7.42705 12 8.75012 10.9248 8.89645 9.6106L8.94988 7.84616L9 4H5.54521C4.49707 4 3.61166 4.72178 3.47595 5.69096C3.43004 6.01884 3.01617 9.08255 3.01617 9.08255C2.83748 10.6872 4.16056 12 5.95632 12Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18.0437 12C16.573 12 15.2499 10.9248 15.1035 9.6106L15.0611 7.86666L15 4H18.4548C19.5029 4 20.3883 4.72178 20.524 5.69096C20.57 6.01884 20.9838 9.08255 20.9838 9.08255C21.1625 10.6871 19.8394 12 18.0437 12Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 12C13.8323 12 15 10.8638 15 9.34659L14.9168 4H9.08318L9 9.34659C8.99983 10.9583 10.1677 12 12 12Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 11V17.8859C20 19.0487 19.0401 20 17.8668 20H6.13317C4.95993 20 4 19.0487 4 17.8859V11'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgStoreBd;
